export const EmailMessagesValue = {
  feedback: {
    subject: 'Feedback - Edge Corrections',
  },
  unratedPro: {
    subject: (proNbr: string) => {return `UNRATED PRO ${proNbr} please rate`}
  }
};
